import { Link } from "react-router-dom";
import SeoHead from "@/components/public/SeoHead";
import { Home, ArrowLeft, Search } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center py-16" data-testid="not-found-page">
      <SeoHead title="Page non trouvée" description="La page que vous cherchez n'existe pas ou a été déplacée." path="" noindex={true} />
      <div className="max-w-lg mx-auto px-4 text-center">
        <p className="text-7xl font-bold text-[#336DBF]/20 mb-4">404</p>
        <h1 className="text-2xl sm:text-3xl font-semibold text-[#062133] tracking-tight mb-3">Page non trouvée</h1>
        <p className="text-[#062133]/60 mb-8">La page que vous cherchez n'existe pas ou a été déplacée.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#336DBF] text-white font-semibold rounded-md hover:bg-[#2A5A9E] transition-colors" data-testid="404-home-link">
            <Home size={18} /> Accueil
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-[#062133]/20 text-[#062133] font-medium rounded-md hover:bg-[#F4F6F8] transition-colors">
            <Search size={18} /> Nos services
          </Link>
          <Link to="/contact" className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-[#062133]/20 text-[#062133] font-medium rounded-md hover:bg-[#F4F6F8] transition-colors">
            <ArrowLeft size={18} /> Contact
          </Link>
        </div>
      </div>
    </div>
  );
}
